// extracted by mini-css-extract-plugin
module.exports = {"Hoverable":"Hoverable_5pgoO","HoverableIcon":"HoverableIcon_7QkE1"};